import { ActionFunction, redirect } from 'react-router-dom';
import { saveData } from './saveData';

// Sentry
import * as Sentry from '@sentry/react';

// Offline / avisos
import { isOfflineQueuedError } from '../../../../../offline/isOfflineQueuedError';
import { showSuccessToast } from '../../../../../utils/toasts';
import i18n from '../../../../../i18n';

export const ActionVehicles: (AccidentRoute: string) => ActionFunction =
  (AccidentRoute) =>
  async ({ request, params }) => {
    const formData = await request.formData();
    try {
      // `await` real: sin él este catch era código muerto (la promesa
      // rechazada nunca pasaba por aquí) y el fallo quedaba silencioso.
      // `params`: el `:id` de la URL es el padre del accidente (S4).
      return await saveData(formData, AccidentRoute, { params });
    } catch (err) {
      if (isOfflineQueuedError(err)) {
        // El accidente se encoló (sin red, o con red degradada tras el plazo):
        // éxito diferido. El destino lo pone quien encoló.
        showSuccessToast(i18n.t('modals:changeState.queuedOffline'));
        return redirect((err as { redirectTo?: string }).redirectTo ?? '../../');
      }
      Sentry.captureException(err);
      console.log('Error save Accident:', err);
      // Re-lanzar → errorElement de la ruta. Antes: `return null` silencioso.
      throw err;
    }
  };
